export default "__VITE_ASSET__CcmUWgfQ__"